import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-icon-orders',
  templateUrl: './icon-orders.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconOrdersComponent {}
